import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import BASE_URL, { getImageUrl } from "../../BASEURL";

export default function Products() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await fetch(`${BASE_URL}/api/product/all`);
      const data = await res.json();
      const productList = Array.isArray(data) ? data : data.products || data.data || [];
      setProducts(Array.isArray(productList) ? productList : []);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };

  const deleteProduct = async (id) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      try {
        const res = await fetch(`${BASE_URL}/api/product/${id}`, { method: "DELETE" });
        if (!res.ok) throw new Error("Delete failed");
        setProducts((prev) => prev.filter((p) => p._id !== id));
      } catch (error) {
        console.error("Delete Error:", error);
      }
    }
  };

  const getProductImage = (product) => {
    const imageSource = Array.isArray(product?.images)
      ? product.images.find((img) => typeof img === "string" && img.trim()) || product?.image
      : product?.images || product?.image;

    return getImageUrl(imageSource, "https://via.placeholder.com/60");
  };

  const getProductPrice = (product) => {
    const firstSize = Array.isArray(product?.sizes) ? product.sizes[0] : null;
    return firstSize?.discountPrice ?? firstSize?.price ?? product?.discountPrice ?? product?.price ?? 0;
  };

  if (loading) return <div>Loading products...</div>;

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Products</h2>
        <Link to="/admin/products/add" className="bg-blue-600 text-white px-4 py-2 rounded">
          Add Product
        </Link>
      </div>
      <div className="bg-white border rounded overflow-x-auto">
        <table className="w-full text-sm text-left border-collapse">
          <thead className="bg-gray-100 border-b">
            <tr>
              <th className="p-2 border-r">Image</th>
              <th className="p-2 border-r">Product</th>
              <th className="p-2 border-r">Category</th>
              <th className="p-2 border-r">Price</th>
              <th className="p-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p) => (
              <tr key={p._id} className="border-b hover:bg-gray-50">
                <td className="p-2 border-r">
                  <img
                    src={getProductImage(p)}
                    alt={p.productName}
                    className="w-12 h-12 object-cover border"
                  />
                </td>
                <td className="p-2 border-r font-bold">{p.productName}</td>
                <td className="p-2 border-r">{p.categoryId?.name || "No Category"}</td>
                <td className="p-2 border-r">₹{getProductPrice(p)}</td>
                <td className="p-2 space-x-2">
                  <button onClick={() => navigate(`/admin/products/edit/${p._id}`)} className="text-blue-600 hover:underline">
                    Edit
                  </button>
                  <button onClick={() => deleteProduct(p._id)} className="text-red-600 hover:underline">
                    Delete
                  </button>
                </td>
              </tr>
            ))}
            {products.length === 0 && (
              <tr><td colSpan="5" className="p-4 text-center">No products found.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
